<template>
  <div>
    <div class="line-three">
      <div class="flex three-class">
        <div class="icon-circle flex-x-y-center">
          <div class="iconfont icon-shouji icons"></div>
        </div>
        <div>
          <div class="my-pro">密保手机</div>
          <div class="id">已设置：{{ $parent.userInfo.mobile }}</div>
        </div>
        <div class="flex-1" v-show="!$parent.userInfo.mobile">
          <div class="flex-end change-password" @click="encryptedPhones">
            绑定
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <el-dialog title="设置密保手机号码" :visible.sync="show_mobile" width="30%">
      <el-input
        placeholder="请设置 密保手机号码"
        v-model="moblieModel.mobile"
      ></el-input>

      <!-- <div class="input clearfix">
        <div class="fl">
          <el-input
            placeholder="请输入图片验证码"
            v-model="moblieModel.captcha"
            clearable
          >
          </el-input>
        </div>
        <div class="fr">
          <img @click="getCapt()" class="codeImg" :src="url" alt="" />
        </div>
      </div> -->
      <div class="input clearfix">
        <div class="fl">
          <el-input
            placeholder="请输入短信验证码"
            v-model="moblieModel.captcha"
            clearable
          >
          </el-input>
        </div>
        <div class="fr">
          <el-button class="get-imgcode" @click="getCode()"
            >获取短信验证码</el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_mobile = false">取 消</el-button>
        <el-button type="primary" @click="changeCellphobe">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCapt, getCode, bindingMobilePhone } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
    }),
  },
  data() {
    return {
      url: "",
      moblieModel: {
        mobile: "",
        captcha_key: "",
        captcha: "",
        event: "changemobile",
      },

      show_mobile: false,
    };
  },
  created() {
    // this.getCapt();
  },
  methods: {
    getCode() {
      getCode(this.moblieModel).then((res) => {
        if (res.data.code === 1) {
          successalert(res.data.msg);
        } else {
          erroralert(res.data.msg);
        }
      });
    },
    getCapt() {
      getCapt().then((res) => {
        if (res.data.code == 1) {
          this.url = res.data.data.captcha;
          this.moblieModel.captcha_key = res.data.data.key;
        }
      });
    },
    changeCellphobe() {
      bindingMobilePhone(this.moblieModel).then((res) => {
        this.resData = res.data.data;
        if (res.data.code === 1) {
          this.show_mobile = false;
          console.log(res.data.data.msg);
          //修改完密码，退出账号
        }
      });
    },
    encryptedPhones() {
      this.show_mobile = true;
    },
  },
  props: {
    // 流程
  },
};
</script>

<style scoped></style>
